import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ProductoAttributes {
  precioFinal: number;
  [key: string]: unknown;
}

interface Producto {
  id: number;
  attributes: ProductoAttributes;
}

interface CarritoItem {
  cantidad: number;
  producto: Producto;
}

interface CarritoState {
  datos: unknown[];
  productos: CarritoItem[];
}

const initialState: CarritoState = {
  datos: [],
  productos: []
};

export const createCarritoSlice = (name: string) => createSlice({
  name,
  initialState,
  reducers: {
    agregarDatos: (state, action: PayloadAction<unknown[]>) => {
      state.datos = action.payload;
    },
    agregarProducto: (state, action: PayloadAction<{ cantidad: number; producto: Producto }>) => {
      const { cantidad, producto } = action.payload;
      const { id } = producto;
      const index = state.productos.findIndex((item) => item.producto.id === id);
      if (index !== -1) {
        state.productos[index].cantidad += cantidad;
      } else {
        state.productos.push({ cantidad, producto });
      }
    },
    quitarProducto: (state, action: PayloadAction<{ cantidad: number; producto: Producto }>) => {
      const { cantidad, producto } = action.payload;
      const { id } = producto;
      const index = state.productos.findIndex((item) => item.producto.id === id);

      if (index !== -1) {
        if (state.productos[index].cantidad > 1) {
          // Resta una unidad si hay más de una
          state.productos[index].cantidad -= cantidad;
        } else {
          // Si solo hay una unidad, elimina el producto del carrito
          state.productos.splice(index, 1);
        }
      }
    },
    vaciarCarrito: (state) => {
      state.productos = [];
    },
    reemplazarCarrito: (state, action: PayloadAction<CarritoItem[]>) => {
      state.productos = action.payload;
    }
  },
});
